module.exports = __webpack_public_path__ + "static/dportenis-logo-e62a6ae781bbc526030df04b32f44fb2.svg";